




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class OnlineStoreIcon extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
